// src/utils/serviceHelpers.ts

import { AnyService, ServiceStatus, ServiceHealth } from '../types/service.type';
import { getServiceConfig } from '../config/serviceConfig';

export const getServiceDisplayName = (service: AnyService): string => {
  const config = getServiceConfig(service.type);
  return `${config.label} - ${service.name}`;
};

export const formatServiceUrl = (url: string | undefined): string => {
  if (!url) return 'N/A';
  return url.replace(/^https?:\/\//, '');
};

export const getServiceAge = (createdAt: Date | string): string => {
  // Convertir a Date si es string
  const date = typeof createdAt === 'string' ? new Date(createdAt) : createdAt;
  
  // Validar que la fecha sea válida
  if (isNaN(date.getTime())) {
    return 'Unknown';
  }
  
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  
  // Si la fecha es en el futuro o muy reciente (menos de 0 días), mostrar "Today"
  if (days < 0) return 'Today';
  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} days ago`;
  if (days < 30) return `${Math.floor(days / 7)} weeks ago`;
  if (days < 365) return `${Math.floor(days / 30)} months ago`;
  return `${Math.floor(days / 365)} years ago`;
};

export const isServiceActionable = (status: ServiceStatus): boolean => {
  return status !== 'deploying' && 
         status !== 'stopping' && 
         status !== 'starting' && 
         status !== 'restarting' &&
         status !== 'deleting' &&
         status !== 'deleted' &&
         status !== 'terminated';
};

export const getHealthColor = (health: ServiceHealth): string => {
  const colors = {
    healthy: 'text-green-600',
    degraded: 'text-yellow-600',
    unhealthy: 'text-red-600',
    unknown: 'text-gray-400',
  };
  return colors[health];
};

export const getHealthBadge = (health: ServiceHealth): string => {
  const badges = {
    healthy: '✓',
    degraded: '⚠',
    unhealthy: '✕',
    unknown: '?',
  };
  return badges[health];
};
